import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import './CheckEmail.scss';
import Logo2 from '../../../components/Logo/Logo2';


const Page404 = () => {
    document.title = 'Error | DB Design';

    return (
        <div className="check-email-box">
            <Logo2 />
            <div className='check-email'>
                <div className="check-email-title not-found" style={{fontSize: '40px'}}>Error</div>
                <div className='check-email-text-wrap'>
                    <p className="check-email-text verified">Something went wrong.</p>
                </div>
                <a href="/" className="check-email-action not-found">
                    <span>Back home</span>
                </a>
            </div>
        </div >
    );
};

export default Page404;
